import React, { useState } from "react";
import { Input, Button, Upload, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Option } = Select;

const FormComponent = () => {
  const [formFields, setFormFields] = useState([
    {
      title: "",
      description: "",
      image: null,
    },
  ]);

  const [selectedValue, setSelectedValue] = useState(""); // State for dropdown

  const handleAddFields = () => {
    const newField = {
      title: "",
      description: "",
      image: null,
    };
    setFormFields([...formFields, newField]);
  };

  const handleInputChange = (index, name, value) => {
    const updatedFields = [...formFields];
    updatedFields[index][name] = value;
    setFormFields(updatedFields);
  };

  const handleImageChange = (index, info) => {
    if (info.fileList.length > 0) {
      const updatedFields = [...formFields];
      updatedFields[index].image = info.fileList[0].originFileObj;
      setFormFields(updatedFields);
    }
  };

  const handleDropdownChange = (value) => {
    setSelectedValue(value);
  };

  const handleSubmit = () => {
    console.log("Form Fields:", formFields);
    console.log("Selected value:", selectedValue);
    // Handle sending formFields and selectedValue to your backend or further processing
  };

  return (
    <div>
      <Select
        className="mb-4 w-full"
        placeholder="Select Option"
        value={selectedValue}
        onChange={handleDropdownChange}
      >
        <Option value="Option 1">Option 1</Option>
        <Option value="Option 2">Option 2</Option>
        {/* Add other options here */}
      </Select>
      {formFields.map((field, index) => (
        <div key={index} className="mb-4">
          <Input
            className="mb-2"
            placeholder="Title"
            value={field.title}
            onChange={(e) => handleInputChange(index, "title", e.target.value)}
          />
          <TextArea
            className="mb-2"
            placeholder="Description"
            value={field.description}
            onChange={(e) =>
              handleInputChange(index, "description", e.target.value)
            }
            rows={4}
          />
          <Upload
            className="mb-2 text-white"
            beforeUpload={() => false}
            onChange={(info) => handleImageChange(index, info)}
            fileList={
              field.image ? [{ uid: "-1", name: "Image", status: "done" }] : []
            }
          >
            <Button className="text-white bg-blue-400" icon={<PlusOutlined />}>
              Upload Image
            </Button>
          </Upload>
        </div>
      ))}
      <Button
        type="primary"
        onClick={handleAddFields}
        className="mb-4 bg-blue-400 mr-5"
      >
        Add Fields
      </Button>
      <Button type="primary" onClick={handleSubmit} className="bg-blue-400">
        Submit
      </Button>
    </div>
  );
};

export default FormComponent;
